module.exports = __webpack_public_path__ + "1c1553d72ea7d2f55d0fe364cd324188.svg";